export function addSelectedIds(selectedIds: string[], idsToAdd: string[]) {
  const next = new Set(selectedIds);
  for (const id of idsToAdd) {
    next.add(id);
  }
  return [...next];
}

export function removeSelectedIds(selectedIds: string[], idsToRemove: string[]) {
  const remove = new Set(idsToRemove);
  return selectedIds.filter((id) => !remove.has(id));
}
